export const getSpecialProductStatusColor = (valueId) => {
  const colors = {
    1: { bg: '#dc3545', text: '#ffffff' }, // Por procesar - Rojo
    2: { bg: '#ffc107', text: '#000000' }, // Pedido al almacén - Amarillo
    3: { bg: '#6f42c1', text: '#ffffff' }, // En el almacén - Morado
    4: { bg: '#198754', text: '#ffffff' }  // Entregado - Verde
  };
  
  return colors[valueId] || { bg: '#6c757d', text: '#ffffff' }; // Gris por defecto
};

export const getSpecialProductStatusBadgeVariant = (valueId) => {
  const variants = {
    1: 'danger',    // Por procesar
    2: 'warning',   // Pedido al almacén
    3: 'secondary', // En el almacén - Morado (usando secondary como aproximación)
    4: 'success'    // Entregado
  };
  
  return variants[valueId] || 'secondary';
};